"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UploadBillingListItems = class UploadBillingListItems extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    onSumbitCompleted(...args) {
        const [event] = args;
        const data = event.data.response.data;
        if (data == null) {
            this.resultText = this.messages.noRecordsHaveBeenImported;
            return;
        }
        const items = data.result ? data.result.length : 0;
        this.resultText = this.$fn.sprintf(this.messages.recordsHaveBeenImported, { items });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    file;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    resultText;
    templateFileURL;
    async $$load_templateFileURL() {
        return this.$fn.urlFor('get_billing_list_items_upload_template', { format: 'xlsx' });
    }
    messages;
    ux;
    b_7315092382398562_modalBindings;
    b_3086171180629160_validation;
    dataMembers = ['file', 'formId', 'formName', 'resultText', 'templateFileURL', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                file: null,
                formId: null,
                formName: "uploadBillingListItems",
                resultText: null,
                templateFileURL: null,
                messages: {
                    noRecordsHaveBeenImported: this.$fn.pgettext("UploadBillingListItems", "No records have been imported."),
                    recordsHaveBeenImported: this.$fn.pgettext("UploadBillingListItems", "%(items)s items have been imported."),
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_3086171180629160_validation: ["ext:xlsx",
                    "required",
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("UploadBillingListItems|Title", "Upload Billing List Items"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2262_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_648747096704084_script_2268_getActionArgs_value($event) {
        this.onSumbitCompleted($event);
    }
    async act_648747096704084_script_2268_getActionArgs($event) {
        return {
            value: () => this.act_648747096704084_script_2268_getActionArgs_value($event),
        };
    }
    async act_648747096704084_request_2266_getActionArgs($event) {
        return {
            operation: "upload_billing_list_items",
            data: {
                file: this.file
            },
            contentType: "multipart/form-data",
        };
    }
    async evh_648747096704084_submit(event, scope) {
        return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_2270_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2262 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2262_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2261 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2262,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2261],
        });
        const act_2248226175642056_closeComponent_2264 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2263 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2264,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2263],
        });
        const act_648747096704084_script_2268 = new core_1.actions.ScriptAction({
            actionArgs: this.act_648747096704084_script_2268_getActionArgs,
            events: [],
        });
        const evh_648747096704084_success_2267 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_script_2268,
            event: "success",
            displayName: "script",
        });
        const act_648747096704084_request_2266 = new core_1.actions.RequestAction({
            actionArgs: this.act_648747096704084_request_2266_getActionArgs,
            displayName: "submit",
            events: [evh_648747096704084_success_2267],
        });
        const evh_648747096704084_submit_2265 = new core_1.actions.EventHandlerImpl({
            action: act_648747096704084_request_2266,
            event: "submit",
            displayName: "submit",
        });
        const evh_648747096704084_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_648747096704084_submit_2265],
        });
        const act_1419464017721962_closeModal_2270 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_2270_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2269 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_2270,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2269],
        });
        return {
            act_7315092382398562_closeModal_2262,
            evh_7315092382398562_close_2261,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2264,
            evh_2248226175642056_close_2263,
            evh_2248226175642056_close,
            act_648747096704084_script_2268,
            evh_648747096704084_success_2267,
            act_648747096704084_request_2266,
            evh_648747096704084_submit_2265,
            evh_648747096704084_submit,
            act_1419464017721962_closeModal_2270,
            evh_1419464017721962_clickPreventStop_2269,
            evh_1419464017721962_clickPreventStop,
            submit: act_648747096704084_request_2266,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UploadBillingListItems.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UploadBillingListItems.prototype, "onSize", null);
UploadBillingListItems = __decorate([
    (0, vue_property_decorator_1.Component)()
], UploadBillingListItems);
exports.default = UploadBillingListItems;
vue_property_decorator_1.Vue.component("UploadBillingListItems", UploadBillingListItems);
